var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-Footer"},[_vm._v("\n    "+_vm._s(("Copyright © 2007 - " + (new Date().getFullYear()) + " " + (_vm.SITE.TITLE)))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }